import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import BackButton from 'components/BackButton';
import { FocusableParent, Focusable } from 'components/navigation';
import { Metadata, Title } from 'components/ContentTitle';

interface IStyledControlsWrapper {
  darkOverlay?: boolean;
  idle?: boolean;
}
export const StyledControlsWrapper = styled.div<IStyledControlsWrapper>`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
  position: absolute;
  top: 0;
  left: 0;
  background: ${({ darkOverlay }) => (darkOverlay ? 'rgba(0, 0, 0, 0.5)' : 'none')};

  &:before {
    width: ${scaleSize(1920)}px;
    height: ${scaleSize(1080)}px;
    display: block;
    content: '';
    background: linear-gradient(to top, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0) ${scaleSize(360)}px),
      linear-gradient(to bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0) ${scaleSize(360)}px);
    position: absolute;
    opacity: ${({ idle }) => (idle ? 0 : 1)};
    top: 0;
    left: 0;
  }
`;

export const StyledBackButton = styled(BackButton)`
  transform: translate3d(-${({ idle }) => (idle ? 300 : 0)}px, 0, 0);
`;

interface IStyledPlayerHeaderWrapper {
  idle?: boolean;
}

export const StyledPlayerHeaderWrapper = styled.div<IStyledPlayerHeaderWrapper>`
  transform: translate3d(0, -${({ idle }) => (idle ? 300 : 0)}px, 0);
  left: ${scaleSize(220)}px;
  position: relative;
`;

export const StyledTitle = styled(Title)`
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(68)}px;
  top: ${scaleSize(33)}px;
  left: 0;
  bottom: auto;
`;

interface IStyledChannelItemLogo {
  logo: string;
}

export const StyledChannelItemLogo = styled.div<IStyledChannelItemLogo>`
  position: absolute;
  top: ${scaleSize(36)}px;
  left: ${scaleSize(-114)}px;
  width: ${scaleSize(100)}px;
  height: ${scaleSize(100)}px;
  background: url(${({ logo }) => logo}) no-repeat center;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  border-radius: ${scaleSize(8)}px;
  background-size: ${scaleSize(90)}px;
  margin: 0 ${scaleSize(40)}px 0 0;
`;

export const StyledMetadata = styled(Metadata)`
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(18)}px;
  top: ${scaleSize(109)}px;
  left: 0;
  & > div > span {
    padding-left: 30px;
  }
`;

export const StyledButtonsWrapper = styled(FocusableParent)`
  width: ${scaleSize(1480)}px;
  height: ${scaleSize(140)}px;
  margin-left: ${scaleSize(220)}px;
  text-align: center;
  position: relative;
`;

interface IStyledControlButton {
  isNotAvailable?: boolean;
}

export const StyledControlButton = styled(Focusable)<IStyledControlButton>`
  width: ${scaleSize(120)}px;
  height: ${scaleSize(120)}px;
  background-color: ${({ theme }) => theme.playerButtonBg};
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  color: #ffffff;
  vertical-align: top;
  box-sizing: border-box;
  opacity: ${({ isNotAvailable }) => (isNotAvailable ? 0.5 : 1)};

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
  }

  &:focus > svg > g {
    fill: ${({ theme }) => theme.focusedTextColor};
  }
`;

interface IStyledControls {
  isSeriesPlayer: boolean;
  idle: boolean;
  bottomOffset: number;
}

export const StyledControls = styled.div<IStyledControls>`
  width: ${scaleSize(1920)}px;
  height: ${({ isSeriesPlayer }) => scaleSize(isSeriesPlayer ? 440 : 300)}px;
  transform: translate3d(
    0,
    ${({ idle, isSeriesPlayer }) => (idle ? (isSeriesPlayer ? 460 : 400) : 0)}px,
    0
  );
  position: absolute;
  bottom: ${({ bottomOffset }) => scaleSize(bottomOffset || 0)}px;
`;
